import { connect } from 'react-redux';
import HeaderCalendar from '../components/header-calendar';
import { setDateReference, setViewWorkingDays } from '../../../containers/gantt-actions';

const mapStateToProps = state => ({
  dateReference: state.gantt.dateReference,
  view: state.gantt.view,
});

const mapDispatchToProps = {
  setDateReference,
  setViewWorkingDays,
};

export default connect(mapStateToProps, mapDispatchToProps)(HeaderCalendar);
